<script setup>
    import {defineProps} from 'vue'
  
    defineProps({
        title: {type: String, default: 'Aguarde ...'},
        tagline: {type: String, default: 'estamos buscando o conteudo desejado.'},
    })
</script>
<template>
    <div class="h-full flex flex-wrap items-center justify-center">
        <div class="flex flex-col items-center ">
            <img
                src="@/assets/images/others/spinner.svg"
                alt=""
                class="w-10 h-10 mr-2"
            >
            <h3 class="mt-2 text-md font-medium text-chat-primary-dark chat_transition dark:text-gray-300">
                {{ title }}
            </h3>
            <p class="mt-1 text-chat-gray chat_transition dark:text-chat-gray text-sm">
                {{ tagline }}
            </p>
        </div>
    </div>
</template>
